import React, { useEffect, useState } from 'react';
import '../scss/main.scss';

const Layout = ({ bodyClass, children, color }) => {
  const [loading, setLoading] = useState(true);
  if (typeof document !== 'undefined') {
    const interval = setInterval(() => {
      if (document.readyState === 'complete') {
        setLoading(false);
        clearInterval(interval);
      }
    }, 100);
  }

  // add / remove body class

  useEffect(() => {
    if (!bodyClass || typeof document === 'undefined') return;

    document.body.classList.add(bodyClass);

    return () => {
      document.body.classList.remove(bodyClass);
    };
  }, [bodyClass])


  return (
    <div
      className={`page-loader ${color === 'lightBrown' ? 'brown-bg' : null}`}
      style={{ opacity: loading ? 0 : 1 }}
    >
      {children}
    </div>
  );
};

export default Layout;
